import { render } from "./PaperCurrency.vue?vue&type=template&id=ca695bde"
import script from "./PaperCurrency.vue?vue&type=script&lang=js"
export * from "./PaperCurrency.vue?vue&type=script&lang=js"
script.render = render

export default script